<script setup>
import AudioPlay from "./components/AudioPlay.vue";
import { ref, defineEmits, watch, defineProps, onUnmounted, computed } from "vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import store from "@/js/store";

const $emits = defineEmits(["submit"]);

const props = defineProps(["linkContent"]);

const ossUrl = `${store.getOEMBASE() || ""}grammar_content/`;

const listenStore = useListenConfigStore();

const fontSize = computed(() => listenStore.fontSize);

const currentAnswer = ref([]);

defineExpose({
  currentAnswer,
});

watch(
  () => props.linkContent,
  (newval, oldval) => {
    if (newval) {
      console.log("测", newval);
      choiceQuestionList.value = props.linkContent.questionDataList;
      audioName.value = props.linkContent.materialAudioUrl;
      choiceQuestionList.value.forEach((item) => {
        if (item.studentAnswer) {
          const index = item.optionList.findIndex((opt) => opt.optionNumber === item.studentAnswer);
          item.optionList[index].checked = true;
          currentAnswer.value.push(item.optionList[index].optionNumber);
        }
      });
    }
  }
);

const timer = ref(null);

const audioName = ref(""); //音频文件名称

const choiceQuestionList = ref([]); //选择题数组

const answeringTime = ref(""); //材料音频时长+每道题10s答题时长

//修改选择题选中状态
const handleOptionChecked = (obj, index, optIdx) => {
  choiceQuestionList.value[index].optionList.forEach((item, idx) => {
    item.checked = false;
    if (idx === optIdx) {
      item.checked = true;
    }
  });
};

//获取音频文件时长
const totalTime = ref(0);
const getDuration = (val) => {
  totalTime.value = val + choiceQuestionList.value.length * 10;
  answeringTime.value = timeFormat(totalTime.value);
};

const startCountDown = () => {
  timer.value = setInterval(() => {
    totalTime.value--;
    if (totalTime.value < 1) {
      totalTime.value = 0;
      clearInterval(timer.value);
      timer.value = null;
    }
    answeringTime.value = timeFormat(totalTime.value);
  }, 1000);
};

//将单位为秒的的时间转换成mm:ss的形式
const timeFormat = (number) => {
  let minute = parseInt(String(number / 60));
  let second = parseInt(String(number % 60));
  minute = minute >= 10 ? minute : "0" + minute;
  second = second >= 10 ? second : "0" + second;
  return minute + ":" + second;
};

//提交测试题
const disabled = ref(false)
const submit = async () => {
  disabled.value = true;
  setTimeout(()=>{
    disabled.value = false;
  },500)
  const questionNumber =
    choiceQuestionList.value[choiceQuestionList.value.length - 1].questionNumber;
  currentAnswer.value = [];
  choiceQuestionList.value.forEach((item) => {
    item.optionList.forEach((p) => {
      if (p.checked) {
        currentAnswer.value.push(p.optionNumber);
      }
    });
  });
  $emits("submit", { titleNumber: questionNumber });
  clearInterval(timer.value);
  timer.value = null;
};

const handlePlay = () => {
  if(timer.value || listenStore.listenPrepare){
    return false
  }
  startCountDown()
};

onUnmounted(() => {
  clearInterval(timer.value);
  timer.value = null;
});
</script>

<template>
  <AudioPlay :audio-name="audioName" @getDuration="getDuration" @play="handlePlay" />
  <div class="choice-question-box" :class="fontSize">
    <ul v-for="(item, index) in choiceQuestionList" :key="item.id" class="card">
      <li class="title">{{ item.question }}</li>
      <li v-for="(opt, optIdx) in item.optionList" :key="opt.value" class="item-option">
        <span
          v-if="!opt.checked"
          class="circle"
          @click="handleOptionChecked(opt, index, optIdx)"
        ></span>
        <span
          v-if="opt.checked"
          class="circle-active"
          @click="handleOptionChecked(opt, index, optIdx)"
        >
          <label class="inner-point"></label>
        </span>
        <!--optionFormat 1=纯文本，2=图片-->
        <div v-if="opt.optionFormat == 1" :class="{ 'item-active': opt.checked }" class="item-cell">
          {{ opt.optionContent }}
        </div>
        <img v-if="opt.optionFormat == 2" class="" alt="" :src="`${ossUrl}${opt.optionContent}`" />
      </li>
    </ul>
  </div>
  <div class="ring-box" v-if="!listenStore.listenPrepare">
    <div class="ring-box_left">
      <img v-show="answeringTime" src="@/assets/listening/icon-ring.svg" alt="" />
      <span v-show="answeringTime">{{ answeringTime }}</span>
    </div>
    <button class="submit-btn" :disabled="disabled" @click="submit">提交</button>
  </div>
</template>

<style scoped lang="less">
@import "components/ThemeTag/listenTheme";
@import "components/ThemeTag/fontSize";
.choice-question-box {
  padding-bottom: 2rem;
  .card {
    padding: 0;
    margin: 0;
    padding: 0.95rem;
    background-color: var(--choice-card-bg-color);
    list-style: none;
    border-radius: 1rem;
    margin-top: 0.64rem;
    gap: 0.76rem;
    display: flex;
    flex-direction: column;
    .title {
      color: var(--text-title-color);
      font-size: var(--step1-title);
      font-weight: 500;
    }
    .item-option {
      font-size: var(--step1-item-text);
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.38rem;
      color: var(--text-color);
      .circle,
      .circle-active {
        width: 1.15rem;
        height: 1.15rem;
        border-radius: 50%;
        border: 1px solid var(--circle-color);
        display: inline-block;
      }
      .circle-active {
        border: 1px solid var(--circle-color-active);
        position: relative;
        .inner-point {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          background-color: var(--circle-color-active);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .item-active {
        color: var(--circle-color-active);
      }
      .item-cell {
        flex: 1;
      }
    }
  }
}
.ring-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ff8c00;
  font-size: 0.9rem;
  padding-top: 0.38rem;
  position: fixed;
  bottom: 3.5rem;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--page-inner-bg);
  img {
    width: 1.1rem;
    height: 1.1rem;
  }
  &_left {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
  }
  .submit-btn {
    height: 1.5rem;
    line-height: 1.5rem;
    background: var(--button-bg-color);
    color: var(--button-text-color);
    box-shadow: 0;
    border-radius: 1rem;
    font-size: 0.9rem;
    padding: 0 0.64rem;
  }
}
</style>
